<template>
    <div class="page_container">
      <div class=" footer_container t_container row">
        <div class="footer_main">        
            <div class="grid footer_content">
                <div class="footer_banner grid grid_xs_12">
                    <div class="footer_column grid_xs_12">
                        <div class="column_title">Information</div>
                        <div class="column_tab" @click="toPages('/about-us')">about us</div>
                        <div class="column_tab" @click="toPages('/shipping-policy')">shipping policy</div>
                        <div class="column_tab" @click="toPages('/privacy-policy')">Privacy Policy</div>
                        <div class="column_tab" @click="toPages('/terms-conditions')">Terms & Conditions</div>
                    </div>
                    <div class="footer_column grid_xs_12">
                        <div class="column_title">Customer Service</div>
                        <div class="column_tab"  @click="toPages('/contact-us')">contact us</div>
                        <div class="column_tab" @click="toPages('/return-policy')">returns policy</div>
                                     
                    </div>
                    <div class="footer_column grid_xs_12">
                        <div class="column_title">my account</div>
                        <div class="column_tab" @click="toAccount">sign in</div>
                        <div class="column_tab" @click="toAccount">orders</div>
                        
                    </div>
                   
                    
                </div>
                <div class='footer_cqQQ  grid_xs_12'>
                    <div class="flex">
                        <img src="../assets/zhifu_1.png" alt="">
                        <img src="../assets/zhifu_2.png" alt="">
                        <img src="../assets/zhifu_3.png" alt="">
                        <img src="../assets/zhifu_4.png" alt="">
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
   




</template>

<script>
export default {
    name: 'ASTRFooter',

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        toPages(path) {
            this.$router.push(path)
        },
        toAccount() {
           this.$router.push('/login')
        }
        
    },
};
</script>

<style lang="scss" scoped>
.footer_container{
    background:#f7f3eb;
    padding-bottom:80px;
}
.footer_main{
    width:100%;
    max-width:1200px;
    margin:0 auto;
    
    .footer_content{
        padding:0 30px;
    }
    .footer_banner{
        grid-column: span 8;
        padding:40px 0 20px;
    }
 
    .footer_column{
        grid-column: span 4;
        color:#000;
        font-family: Montserrat,sans-serif;
        font-size: 12px;
        font-weight: 300;
        text-decoration: none;
        text-align: left;
        padding-right:40px;
        font-family: neo-sans, "Helvetica Neue", Helvetica, Arial, sans-serif;
        text-transform: capitalize;
        .column_title{
            font-size:14px;
            font-weight:600;
            margin:10px 0;
        }
        .column_tab{   
            padding-bottom:3px;
            cursor: pointer;
            font-weight:300;
            &:hover{
                text-decoration: underline;
            }
        }
    }
    .footer_cqQQ{
        grid-column:span 4;
        position: relative;
        .flex{
            display: flex;
            margin-top:100px;
            justify-content: center;
            align-items: center;
            >img{
                height: 40px;
                width: auto;
                padding: 0 4px;
            }
        }
    }

}
</style>


// WEBPACK FOOTER //
// src/components/footer.vue